<template>
    <CModal class="ActionModal" :stretch="stretch" :width="width" @before-close="handleCloseAttempt($event)" @close="close">
        <div v-if="showImage" class="mx-auto mb-8 mt-24 flex justify-center sm:mb-6 sm:mt-8">
            <slot v-if="$slots.image" name="image" />
            <div v-else class="flex size-20 items-center justify-center rounded-full border shadow-md">
                <CIcon
                    class="text-green-500"
                    :class="{
                        'text-red-500': icon === 'close',
                        'text-primary-500': icon === 'duration'
                    }"
                    :name="icon"
                    size="large"
                />
            </div>
        </div>
        <div class="mx-6 mt-10 space-y-12 text-center">
            <CHeading v-if="$slots.title || title" tag="h1" variant="3">
                <slot v-if="$slots.title" name="title" />
                <template v-else> {{ title }}</template>
            </CHeading>
            <p v-if="text">{{ text }}</p>
            <slot v-if="$slots.default" />
        </div>
        <template #footer>
            <div class="text-center">
                <slot v-if="$slots.footer" name="footer" />
                <CButton v-else class="w-full sm:w-1/2" size="large" variant="primary-150" @click="close()">
                    OK
                </CButton>
            </div>
        </template>
    </CModal>
</template>

<script setup lang="ts">
import { useSlots } from 'vue'

const slots = useSlots()

const props = defineProps({
    title: {
        type: String,
        default: 'Hotovo'
    },
    icon: {
        type: String,
        default: 'checkmark'
    },
    text: {
        type: String,
        default: ''
    },
    stretch: {
        type: Boolean,
        default: false
    },
    showImage: {
        type: Boolean,
        default: false
    },
    width: {
        type: [String, Number],
        default: undefined
    }
})

const emit = defineEmits(['close', 'before-close'])

// X / backdrop dismissal: vue-final-modal's `before-close` is a confirmation hook —
// CModal only fires `close` if we call the submit callback. Without this call the
// modal vanished visually but its stack entry stayed alive, leaving an invisible
// overlay that swallowed subsequent dashboard clicks. We auto-confirm dismissal
// here so every action modal closes cleanly, and still forward `before-close` for
// any consumer that wants to intercept.
const handleCloseAttempt = (submit: () => void) => {
    emit('before-close', submit)
    submit()
}

const close = () => {
    emit('close')
}
</script>
